import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    breakTimes: Array
  }
  static targets = [
    "timeSlice",
    "sliceStart",
    "sliceEnd",
    "workTime",
    "manDay",
    "tool",
    "toolTime",
    "toolManDays"
  ]

  handleTimeSliceChange(event) {
    const selected = event.target.options[event.target.selectedIndex]
    if (!selected.dataset.timeSlice) return

    const data = JSON.parse(selected.dataset.timeSlice)

    if (this.hasSliceStartTarget) {
      this.sliceStartTarget.value = data.start_time || ""
    }

    if (this.hasSliceEndTarget) {
      this.sliceEndTarget.value = data.end_time || ""
    }

    if (this.hasManDayTarget) {
      this.manDayTarget.value = data.man_days || ""
    }

    this.calculateTime()
  }

  calculateTime() {
    if (!this.hasSliceStartTarget || !this.hasSliceEndTarget || !this.hasWorkTimeTarget) return
    
    const startTime = this.sliceStartTarget.value
    const endTime = this.sliceEndTarget.value

    if (!startTime || !endTime) {
      this.workTimeTarget.value = ""
      this.handleToolChange()
      return
    }

    const startMin = this.toMinutes(startTime)
    let endMin = this.toMinutes(endTime)

    if (endMin < startMin) {
      endMin += 24 * 60
    }

    let totalMin = endMin - startMin

    if (this.hasBreakTimesValue && this.breakTimesValue.length > 0) {
      this.breakTimesValue.forEach(b => {
        const breakStart = this.toMinutes(b.start || b.start_time)
        const breakEnd = this.toMinutes(b.end || b.end_time)
        if (breakStart < endMin && breakEnd > startMin) {
          const overlapStart = Math.max(startMin, breakStart)
          const overlapEnd = Math.min(endMin, breakEnd)
          totalMin -= (overlapEnd - overlapStart)
        }
      })
    }
    
    if (totalMin < 0) totalMin = 0

    const hh = Math.floor(totalMin / 60).toString().padStart(2, '0')
    const mm = (totalMin % 60).toString().padStart(2, '0')
    this.workTimeTarget.value = `${hh}:${mm}`

    this.handleToolChange()
  }

  toMinutes(timeStr) {
    if (!timeStr) return 0
    const [h, m] = timeStr.split(":").map(Number)
    return h * 60 + (m || 0)
  }

  handleToolChange() {
    if (!this.hasToolTarget || !this.toolTarget.value || (!this.workTimeTarget.value && !this.manDayTarget.value)) {
      if (this.hasToolTimeTarget) this.toolTimeTarget.value = ""
      if (this.hasToolManDaysTarget) this.toolManDaysTarget.value = ""
      return
    }

    if (this.hasToolTimeTarget && this.hasWorkTimeTarget) {
      this.toolTimeTarget.value = this.workTimeTarget.value
    }
    if (this.hasToolManDaysTarget && this.hasManDayTarget) {
      this.toolManDaysTarget.value = this.manDayTarget.value
    }
  }

  validateManDays(event) {
    if (!this.hasManDayTarget) return

    const form = this.element
    if (!form.dataset.dailyTotalManDays) return

    const currentDailyTotal = parseFloat(form.dataset.dailyTotalManDays) || 0
    const cellOriginalValue = parseFloat(form.dataset.currentCellManDays) || 0
    const newValue = parseFloat(this.manDayTarget.value) || 0

    const baseTotal = currentDailyTotal - cellOriginalValue
    const newTotal = baseTotal + newValue

    if (newTotal > 1.0) {
      if (!confirm(`「工数合計が１人工を超えますが、保存しますか？」`)) {
        event.preventDefault()
      }
    }
  }
}